import React, { useState, useEffect } from 'react';
import { FiClock } from 'react-icons/fi';

const SaleTimer = () => {
    const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });

    useEffect(() => {
        const calculateTimeLeft = () => {
            const now = new Date();
            const currentHours = now.getHours();

            // Determine next 12-hour mark (Noon 12:00 or Midnight 00:00/24:00)
            // If currently 10AM, target is 12PM. 
            // If currently 1PM, target is 12AM (tomorrow).

            let target = new Date(now);
            target.setMinutes(0);
            target.setSeconds(0);
            target.setMilliseconds(0);

            if (currentHours < 12) {
                target.setHours(12);
            } else {
                target.setHours(24);
            }

            const diff = target - now;

            // Fallback if diff is negative (shouldn't happen with above logic but safe guard)
            if (diff < 0) return { hours: 11, minutes: 59, seconds: 59 };

            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / 1000 / 60) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            setTimeLeft({ hours, minutes, seconds });
        };

        calculateTimeLeft();
        const timer = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(timer);
    }, []);

    const format = (num) => num.toString().padStart(2, '0');

    return (
        <div className="flex items-center gap-4 bg-gradient-to-r from-red-500/10 to-transparent border-l-4 border-red-500 p-4 rounded-r-xl mb-6 animate-pulse-slow">
            <div className="p-2 bg-red-500 rounded-full text-white">
                <FiClock className="text-xl" />
            </div>
            <div>
                <p className="text-red-400 text-xs font-bold uppercase tracking-wider mb-0.5">Limited Time Offer</p>
                <p className="text-white font-mono text-xl font-bold tracking-widest">
                    {format(timeLeft.hours)}h : {format(timeLeft.minutes)}m : {format(timeLeft.seconds)}s
                </p>
            </div>
            <div className="ml-auto text-xs text-gray-500 hidden sm:block">
                Reset in 12h
            </div>
        </div>
    );
};

export default SaleTimer;
